import MESSAGES from 'constants/messages';
import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';

export const validate = ({ name, order }, props) => {
  const errors = {};

  if (!name || stringIsInvalid(name)) {
    errors.name = MESSAGES.RULE_GROUPS.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(name)) {
    errors.name = MESSAGES.RULE_GROUPS.NAME.MAX_LENGTH;
  }

  if (
    !order ||
    +order > props.orderList.length ||
    order <= 0 ||
    props.orderList.length === 0
  ) {
    errors.order = MESSAGES.RULE_GROUPS.ORDER;
  }

  return errors;
};

export default validate;
